import React from 'react';
import { TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';

const AutocompleteSearch = ({ value, setValue, options, optionsDisplay, label, ...restProps }) => {
  return (
    <Autocomplete
      options={options}
      getOptionLabel={optionsDisplay}
      value={value}
      onChange={(event, newValue) => setValue(newValue)}
      getOptionSelected={(option, value) => option.id === value.id}
      renderInput={params => <TextField {...params} label={label} margin="dense" />}
      {...restProps}
    />
  );
};

export default AutocompleteSearch;
